import { type UseQueryResult, useQuery } from 'react-query';
import { TableParams } from '../../types/common';
import {
  TradeOrderService,
  Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto_Wealthlane_AwardSettlementService_Application_Contracts,
} from '../../services/wealthlane-award-settlement-services';

const useGetTradeOrderPlaceOrders = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_TradeOrder_TradeOrderDataDto_Wealthlane_AwardSettlementService_Application_Contracts
  | undefined,
  unknown
> => {
  const {
    companyIds,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    orderStatusId,
    createdDate,
    companyTicker,
  } = tableInfo;

  const getTradeOrderPlaceOrders = useQuery(
    [
      'getTradeOrderPlaceOrders',
      companyIds,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      orderStatusId,
      createdDate,
      companyTicker,
    ],
    async () => {
      return await handleRequest(
        TradeOrderService.getApiAwardSettlementApiAppTradeOrderPlacedOrders(
          [orderStatusId],
          undefined,
          createdDate,
          filter,
          companyIds,
          [companyTicker],
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return getTradeOrderPlaceOrders;
};

export default useGetTradeOrderPlaceOrders;
